Drupal.behaviors.sw_ajax_form = {
	attach: function( context, settings ) {
		$('.js-ajax-filter').once('js-ajax-filter').each(function() {
			var f = new AjaxFilter($(this));
		});
	}
};

var AjaxFilter = function( $wrap ) {
	var _this = this;

	this.$wrap = $wrap;

	this.wrap_id = this.$wrap.attr('id');
	this.url_current = this.href_process ( window.location.href );
	this.submit_timeout = false;
	this.is_loading = false;

	this.$wrap.on('submit', 'form', function( e ) {
		if ( !e.isDefaultPrevented() ) {
			e.preventDefault();
			_this.submit($(this));
		}
	});

	this.$wrap.on('keyup change', 'input,select', function( e ) {
		if ( _this.is_loading ) {
			return;
		}
		var $form = $(this).closest('form');
		if ( _this.submit_timeout ) {
			clearTimeout(_this.submit_timeout);
		}
		_this.submit_timeout = setTimeout(function() {
			_this.submit($form);
		}, 1000 );
	});

	// History listener
	window.addEventListener('popstate', function(e){
		if ( typeof e.state == 'object' ) {
			if ( e.state ) {
				if ( e.state.hasOwnProperty('ajax_url') ) {
					//console.log ( 'ajaxify history pop', _this.url_combine ( e.state.ajax_url ));
					var url = e.state.ajax_url;
					if ( e.state.ajax_is_document_replaced ) {
						window.location.href = url;
					} else {
						//console.log ( url, _this.url_current );
						if ( _this.load(url, true) ) {
							e.preventDefault();
						}
					}
				}
			}
		}
	}, false);

	// Push current url to history
	if ( typeof history.replaceState != 'undefined' ) {
		history.replaceState ( {
			ajax_url: this.url_current,
		}, document.title );
	}
};

AjaxFilter.prototype.submit = function($form) {
	// Check form method: POST/GET
	var regex = /^post$/i;
	var is_post = regex.test ( $form.attr('method'));

	// Clone current processed URL
	var url = $.extend ( true, {}, this.url_current );

	if ( !is_post ) {
		var qa = $form.serializeArray();
		// attempt to insert indexes to multi values
		// this should fix occasional reloads with multi-value GET form submissions
		var mfs = [];
		for ( var i in qa ) {
			var qai = qa[i];
			// if multi without index
			var m;
			if (( m = /^(.+?)\[([0-9]*)\]$/i.exec(qai.name))) {
				var name = m[1];
				var ind = parseInt( m[2] );
				ind = ind ? ind : 0;
				if ( !ind && typeof mfs[name] !== 'undefined' ) {
					ind = mfs[name] + 1;
				}
				mfs[name] = ind;
				// set new name
				qa[i].name = name+'['+ind+']';
			}
		}
		// build query
		var qas = [];
		for ( var i in qa ) {
			var qai = qa[i];
			qas.push(encodeURIComponent(qai.name)+'='+encodeURIComponent(qai.value));
		}
		url.query = qas.join('&');
	}

	this.load ( url );
};

/**
 * Perform AJAX load of form submit
 * @param url - page URL to retrieve
 */
AjaxFilter.prototype.load = function ( url, force_no_push ) {
	var _this = this;

	_this.is_loading = true;
	if ( _this.submit_timeout ) {
		clearTimeout(_this.submit_timeout);
	}

	// Get combined URL
	var url_combined = this.url_combine ( url );
	console.log ( 'ajax load', url_combined );

	// Add wait
	this.$wrap.addClass('js-ajax-filter-loading');
	this.$wrap.append(wait());

	// Function to be called on success ajax load
	function done ( resp ) {

    // If we retrieved new page URL
    var js_url = xhr.responseURL;
    if ( !js_url) {
      js_url = $(resp).find('.js-url').data('url');
    }
    if ( !js_url ) {
      js_url = $(resp).filter('.js-url').data('url');
    }
    if ( js_url ) {
      // Cache current fragment
      var fr = url.fragment;
      // Process new URL
      url = _this.href_process(js_url);
      // If fragment
      if ( fr ) {
        // Add to new URl
        url.fragment = fr;
      }
      // Update combined URL
      url_combined = _this.url_combine(url);
    }

		var $resp = $(resp);
		// Find response part
		var $resp_wrap;
		$resp_wrap = $resp.filter ( '#'+_this.wrap_id );
		if ( !$resp_wrap.length ) {
			$resp_wrap = $resp.find ( '#'+_this.wrap_id );
		}
		// If there's more than 1 block in response
		if ( $resp_wrap.length > 1 ) {
			// Use first
			$resp_wrap = $resp_wrap.first();
		}
		// If no wrap, potential external or admin page
		if ( !$resp_wrap.length ) {
			window.location.href = _this.url_combine(url);
			return;
		}

		// Update history
		if ( typeof history.pushState != 'undefined' && !force_no_push ) {
			console.log ( 'ajaxify history push', url_combined );
			history.pushState ( {
				ajax_url: url,
			}, document.title, url_combined );
		}

		// Update current URL
		_this.url_current = url;

		//_this.$wrap.animate({opacity:0},{duration:50});

		setTimeout(function () {
			_this.$wrap.css({opacity:0});

			// Update HTML
			_this.$wrap.html ( $resp_wrap.html () );

			_this.$wrap.animate({opacity:1},{duration:0});
			_this.$wrap.removeClass('js-ajax-filter-loading');
			remove_wait(_this.$wrap);

			setTimeout(function() {
				Drupal.attachBehaviors();
				_this.is_loading = false;
			}, 0);

		}, 0 );
	}

	var xhr = new XMLHttpRequest();

	// Perform AJAX request
	$.ajax({
		url: url_combined,
		method: 'GET',
		data:  undefined,
		processData: true,
		contentType: false,
		cache: true,
		dataType: 'html',
		xhr: function() {
			return xhr;
		},
		success: function ( resp, status ) {
			done ( resp );
		},
		error: function ( xhr, status, error ) {
			console.log ( 'ajaxify error', status, error );
			if ( status === 'abort' ) {
				// do nothing
			} else {
				var resp = xhr.responseText;
				// If we have ajaxify wrap inside
				if ( $(resp).find('#site-content').lengtn ) {
					// Proceed as normal
					done ( resp );
				} else {
					alert('AJAX error! ' + status + ', ' + error);
					_this.$wrap.removeClass('js-ajax-filter-loading');
					remove_wait(_this.$wrap);
					_this.is_loading = false;
				}
			}
		}
	});
};

/**
 * Splits href into parts and refuce special links, like tel: mailto:
 * @param href
 * @returns {*}
 */
AjaxFilter.prototype.href_process = function ( href ) {
	if ( href ) {
		// Skip special links
		if (href.match(/^(tel:|mailto:)/gi)) {
			return false;
		}
		// Skip links to some file extensions (download links)
		if (href.match(/\.(pdf|png|jpeg|jpg|bmp|gif|tiff|ico)$/gi)) {
			return false;
		}
	}
	// Initial values
	var parts = {
		domain: false,
		path: false,
		query: false,
		fragment: false
	};
	// Main regex
	var regex = /^(https?:)?(\/\/)?([^\/]+\/)?([^\?#]+)?(\?[^#]+)?(#.{0,})?$/gi;
	var m = regex.exec ( href );
	if ( m ) {
		var proto = 	m[1] ? m[1].replace(':','') : '';
		var slashes = 	m[2] ? m[2] : '';
		var domain = 	m[3] ? m[3].replace('/','') : '';
		var path = 		m[4] ? m[4] : '';
		var query = 	m[5] ? m[5].replace('?','') : '';
		var fragment =	m[6] ? m[6].replace('#','') : '';
		// If no slashed in the beginning, then part of path got to domain, fix this
		if ( !slashes && domain ) {
			path = domain+'/'+path;
			domain = false;
		}
		// No domain specified
		if ( !domain ) {
			// Set current domain
			domain = this.url_current.domain;
			// If path starts with /
			var absolute = /^\//gi.test ( path );
			if ( absolute ) {
				// Remove /, path is ready
				path = path.replace(/^\//gi,'');
				// If not, but there's some path
			} else if ( path ) {
				// Add path to current base path
				path = this.base_path ( this.url_current.path ) +'/'+path;
				// Empty path
			} else {
				// Use current path
				path = this.url_current.path;
			}
		}
		// If path contains only slash (homepage)
		if ( path == '/' ) {
			// Remove it
			path = '';
		}
		// Set parts
		parts.domain = domain;
		parts.path = path;
		parts.query = query;
		parts.fragment = fragment;
	} else {
		return false;
	}
	//console.log ( parts );
	return parts;
};

/**
 * Conmine parts of URL into URL string
 * @param url_parts
 * @returns {string}
 */
AjaxFilter.prototype.url_combine = function ( url_parts ) {
	// Domain + Path
	var url = ( url_parts.domain ? '//'+url_parts.domain : '' ) + '/' + ( url_parts.path ? url_parts.path : '' );
	// Query
	if ( url_parts.query ) {
		url += '?'+url_parts.query;
	}
	// Fragment
	if ( url_parts.fragment ) {
		url += '#'+url_parts.fragment;
	}
	return url;
};
